import axios from "axios";
import {convertSHA} from "./ExtracurricularCoursesToken"

export const GET_ALL_CS = "GET_ALL_CS";
export const GET_CS = "GET_CS";
export const GET_POSITION = "GET_POSITION";
export const CACS_LOADING = "CACS_LOADING";
export const ADD_CS = "ADD_CS";
export const GET_FILTER = "GET_FILTER";
export const GET_USERS_FILE = "GET_USERS_FILE";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL_EXTRACURRICULAR,
  withCredentials: false,
  headers: {
    'Access-Control-Allow-Origin' : '*',
    'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
    }
});


export const getAllCouseSchedule = () => {
  var Token = convertSHA()
  return async dispatch => {
    dispatch({
      type: CACS_LOADING
    });
    await instance.get(`/DefinitionCourse/GetAllDefinitionCourses/${Token}`).then((res => {
        dispatch({
            type: GET_ALL_CS,
            data: res.data
            });
      console.log("Resp", res);
      }
      )).catch(function(error){
        console.log("Error", error);
      });
  } 
};

//Obtener Shedule ID

export const GetCouseScheduleById = (id) => {
  var Token = convertSHA()
  return async dispatch => {
    dispatch({
      type: CACS_LOADING
    });
    await instance.get(`/DefinitionCourse/GetDefinitionCourseById/${id}&${Token}`).then((res => {
        dispatch({
            type: GET_CS,
            data: res.data
            })
      console.log("Resp", res);
      }
      )).catch(function(error){
        console.log("Error", error);
      });
  } 
};

function formatDate(date) {
  var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

  if (month.length < 2) 
      month = '0' + month;
  if (day.length < 2) 
      day = '0' + day;

  return [year, month, day].join('-') + 'T00:00:00';
}

export const addCouseSchedule = (data,users) =>{
  if(data.mailIns ==''){
    data.mailIns='-1'
  }
  if(data.urlSession==''){
    data.urlSession='-1'
  }
  if(data.badge==''){
    data.badge='0'
  }
  if(data.lob_id ==''){
    data.lob_id='-1'
  }
  if(data.pos_id ==''){
    data.pos_id='-1'
  }
  var usu_id ='';
  for(var i =0; i<users.length; i++){
    usu_id += users[i].badge + '*-*'
  }
  usu_id = usu_id.substring(0, usu_id.length - 3)
  data.start_Date= formatDate(data.start_Date);
  data.end_Date= formatDate(data.end_Date);
  var Token = convertSHA()
  const config = { headers: { 'Access-Control-Allow-Origin': '*','content-type': 'multipart/form-data' } }
  let formData = new FormData();
  formData.append('URLSession', data.urlSession);
  formData.append('Token', Token);
  formData.append('Description', data.description);
  formData.append('Filter', data.filter);
  formData.append('UsersList', usu_id);
  formData.append('LOBList', data.lob_id);
  formData.append('PuestoList', data.pos_id);
  formData.append('ViewQuota', data.viewQuota);

  //&${encodeURI(data.urlSession.replaceAll('/','RR',).replaceAll('https:','urls').replaceAll('http:','url').replaceAll('?','FF').replaceAll('=','DD').replaceAll('&','FDD'))}
     return async dispatch => {
        dispatch({
            type: CACS_LOADING
          });
        console.log(data)
        //axios.defaults.headers.common["Authorization"] = "Bearer " +  localStorage.getItem("jwt_token");
        await instance.put(`/DefinitionCourse/PutInsUpdtDefinitionCourse/${data.id}&${data.cur_id}&${data.roo_id}&${data.badge}&${data.instructor}&${data.start_Date}&${data.end_Date}&${data.start_Time}&${data.end_Time}&${data.day}&${data.quota}&${data.sta_id}&${data.active}&${data.modified_By}&${data.mailIns}`, formData, config ).then((res => {
            dispatch({
                type: ADD_CS,
                data: res.data
                
            });
            console.log(res.data)
        })).catch(function(error){
          console.log("Error", error);
        });
    }
}

export const getAllPositions = () => {
  var Token = convertSHA()
  return async dispatch => {
    dispatch({
      type: CACS_LOADING
    });
    await instance.get(`/DefinitionCourse/GetAllPositions/${Token}`).then((res => {
        dispatch({
            type: GET_POSITION,
            data: res.data
            });
      console.log("Resp", res);
      }
      )).catch(function(error){
        console.log("Error", error);
      });
  } 
};

export const getFilterByDefinition = (id) => {
  var Token = convertSHA()
  return async dispatch => {
    dispatch({
      type: CACS_LOADING
    });
    await instance.get(`/DefinitionCourse/GetFilterByDefinitionCourse/${id}&${Token}`).then((res => {
        dispatch({
            type: GET_FILTER,
            data: res.data
            });
      console.log("Resp", res);
      }
      )).catch(function(error){
        console.log("Error", error);
      });
  } 
};

export const GetUserFile = (file) => {
  var Token = convertSHA()
  const config = { headers: { 'Access-Control-Allow-Origin': '*','content-type': 'multipart/form-data' } }
  let formData = new FormData();
  formData.append('files', file);
  return async dispatch => {
    dispatch({
      type: CACS_LOADING
    });
    await instance.put(`/DefinitionCourse/PutUsersFiles/${Token}`, formData, config).then((res => {
        dispatch({
            type: GET_USERS_FILE,
            data: res.data
            })
      console.log("Resp", res);
      }
      )).catch(function(error){
        console.log("Error", error);
      });
  } 
};